module.exports = __webpack_public_path__ + "img/brand-gitlab.ffbbc64a.svg";